<template>
  <div class="base-button" :key="key">
    <button
      v-if="styleType === 'default'"
      class="customBtn"
      :class="[
        {
          round,
          fixed,
          reverse,
          icon_right,
          disabled,
          minimalize,
          active,
          loading,
          icon_only: icon_only || !text,

        },
        customClass,
      ]"
      :style="{
        width: (width || size) + 'px',
        height: (round ? size : size || height) + 'px',
        padding: padding ? padding + 'px !important' : '',
        borderRadius: borderRadius ? borderRadius + 'px !important' : '',
        backgroundColor: backgroundColor || '',
      }"
      :type="type"
      @click="$listeners ? $listeners : handleClick"
      v-bind="$props"
      v-on="$listeners"
      :disabled="disabled"
    >
      <template v-if="!icon_only">
        <slot name="icon">
          <BaseIcon
            v-if="default_icon"
            :icon="default_icon"
            :width="iconWidth"
            :height="iconHeight"
            :color="iconColor"
          />
        </slot>
        <div class="text">
          <span
            class="f14 fw500"
            :class="minimalize ? 'text__primary' : reverse ? 'text__reverse' : 'text__main'"
            >{{ text }}</span
          >
          <span class="f10 fw300 text__second" v-if="textSecond">{{ textSecond }}</span>
        </div>
        <div v-if="$slots.append" class="ml-3">
          <slot name="append" />
        </div>

      </template>
      <template v-else>
        <slot v-if="!active" name="icon">
          <BaseIcon
            v-if="default_icon"
            :icon="default_icon"
            :width="iconWidth"
            :height="iconHeight"
            :color="iconColor"
          />
        </slot>
        <span v-else>{{ text }}</span>
      </template>
    </button>
    <v-btn
      v-else-if="styleType === 'chip'"
      class="text-none chip secondary--text"
      :color="backgroundColor || 'white'"
      rounded
      :disabled="disabled"
      @click="handleClick"
    >
      {{ text }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'BaseButton',
  props: {
    pdf: Boolean,
    text: String,
    textSecond: String,
    fixed: Boolean,
    reverse: Boolean,
    default_icon: String,
    icon_right: Boolean,
    icon_only: Boolean,
    disabled: [Boolean, String],
    minimalize: Boolean,
    round: Boolean,
    type: {
      type: String,
      default: 'button',
    },
    active: Boolean,
    width: { type: [Number, String], default: null },
    height: {
      type: [Number, String],
      default: 48,
    },
    size: {
      type: [Number, String, Function],
      default: null,
    },
    loading: Boolean,
    customClass: [String, Object],
    iconWidth: {
      type: [Number, String],
      default: null,
    },
    iconHeight: {
      type: [Number, String],
      default: null,
    },
    padding: [String, Number],
    borderRadius: [String, Number],
    backgroundColor: String,
    styleType: {
      type: String,
      default: 'default',
    },
    iconColor: {
      type: String,
    },

  },
  data() {
    return {
      key: 0,
    }
  },
  watch: {
    $props: {
      deep: true,
      handler() {
        this.key++
      },
    },
  },
  methods: {
    handleClick(v) {
      this.$emit('click')
    },
  },
}
</script>

<style lang="scss" scoped>
.base-button:deep() {
  display: inline-block;
  &.icon_right {
    svg {
      order: 2;
      margin-right: 0;
      margin-left: 5px;
    }
  }
  .customBtn {
    display: flex;
    gap: 3px;
    &:hover {
      .text__reverse {
        color: #f2f2f2;
      }
    }
  }
  .text {
    display: grid;
    justify-content: flex-start;
    &__primary {
      color: #277faf;
    }
    &__reverse {
      color: #277faf;
    }
    &__main {
      color: #f2f2f2;
    }
    &__second {
      color: #e0e0e0;
      text-align: start;
    }
  }
  .v-btn {
    height: auto !important;
    transition-property: all;
    transition-timing-function: ease-in-out;
    transition-duration: 0.3s;

    &.chip {
      padding: 10px 20px !important;
      box-shadow: 0 4px 4px rgba(160, 160, 160, 0.25);

      @media #{map-get($display-breakpoints, 'sm-and-down')} {
        font-size: 12px !important;
        padding: 8px 12px !important;
      }

      &:hover {
        color: #2c2c2c !important;
        box-shadow: none;
      }

      &.v-btn--disabled {
        background-color: white !important;
        color: #277faf !important;
      }
    }
  }
}
</style>
